<template>
  <resource-create-wrapper
    :title="item ? $t('resources.headers.duplicate_header') : $t('resources.headers.new_header')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['headerForm'].submit()">
    <HeaderForm :header="item" @isDirtyForm="isDirtyForm" ref="headerForm"></HeaderForm>
  </resource-create-wrapper>
</template>

<script>
  import HeaderForm from "@/components/forms/HeaderForm";
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      HeaderForm,
      ResourceCreateWrapper,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
